<template>
  <li>
    <div class='block-small-media live-video-container'>
      <span v-if='isPostponed'>
        <div class='live-video-meta rec active'>{{textPostponed}}</div>
        <img :src='imageSrc' :alt='item.altText' />
      </span>
      <a v-else :href='item.videoLink' class='video-play-button small'>
        <div v-if='isBefore' class='live-video-meta time active'>{{textClock}} {{item.startTime}}</div>
        <div v-else-if='isActive' class='live-video-meta live active'>{{textLive}}</div>
        <div v-else class='live-video-meta rec active'>{{textRecording}}</div>
        <img :src='imageSrc' :alt='item.altText' />
      </a>
    </div>
    <slider-item-information :item='item'></slider-item-information>
  </li>
</template>

<script>
  import mixins from '../../mixins'
  import lang from '../../lang'
  import consts from '../../consts'
  import SliderItemInformation from './SliderItemInformation'

  export default {
    mixins: [mixins],
    name: 'slider-item-link',
    components: {
      SliderItemInformation
    },
    data () {
      return {
        textClock: lang.clock[this.$root.cmsData.lang],
        textLive: lang.live[this.$root.cmsData.lang],
        textRecording: lang.recording[this.$root.cmsData.lang],
        textPostponed: lang.postponed[this.$root.cmsData.lang],
        imageSrc: undefined
      }
    },
    computed: {
      isBefore: function () {
        return this.item.status === consts.status.before
      },
      isActive: function () {
        return this.item.status === consts.status.active
      },
      isAfter: function () {
        return this.item.status === consts.status.finished
      },
      isPostponed: function () {
        return this.item.status === consts.status.postponed
      }
    },
    created () {
      if (this.isActive) {
        this.imageSrc = this.item.fallback

        let snapshotUrl = this.item.snapshot.indexOf('?') > -1 ? `${this.item.snapshot}&size=small` : `${this.item.snapshot}?size=small`
        if (snapshotUrl) {
          this.$http.get(snapshotUrl).then(response => {
            this.imageSrc = snapshotUrl
          }, response => {
            console.log('Failed to get snapshot for slider item ' + this.item.id + ': ', response)
          })
        }
      } else {
        this.imageSrc = this.item.fallback
      }
    },
    props: ['item']
  }
</script>



// WEBPACK FOOTER //
// SliderItemLink.vue?a1cd6780